
        <div class="layout-footer p-d-flex p-ai-center p-p-4 p-shadow-2">
            <div class="p-col-12">
                <div class="p-grid">
                    <div class="p-col-12" *ngIf="showCookiePolicy" style="font-size: 16px;">                
                        We've updated our policies, by continuing to use this application, you agree to the use of cookies and similar tracking technologies described in our
                        <p-button label="Cookie Notice" styleClass="p-button-link" (click)="showPolicy(3)"></p-button>                                   
                    </div>
                    <div class="p-col-12 p-lg-5 p-md-4"></div>
                    <div class="p-col-12 p-lg-2 p-md-4" *ngIf="showCookiePolicy">
                         <p-button styleClass="fullwidthbtn" label="I agree" (click)="agreeCookiePolicy()"></p-button>
                    </div>
                    <div class="p-col-12 p-lg-5 p-md-4"></div>
                    <div class="p-col-12" style="text-align: center; width: 100%;">
                        <p>© {{currentYear}} All Rights Reserved. NAI Global</p>           
                    </div>       
                </div>               
            </div>           
        </div>        
    